export function normalizeName(value: string): string {
  return value.trim().toLocaleLowerCase()
}
